import styled, { keyframes } from 'styled-components';

interface ITripleSlashProps {
  color?: string;
}

const animation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const IconContainer = styled.svg`
  path {
    animation: ${animation} 2s infinite;

    &:nth-child(2) {
      animation-delay: 0.1s;
    }
    &:nth-child(3) {
      animation-delay: 0.2s;
    }
  }
`;

const TripleSlashIcon = ({ color = '#5496C6' }: ITripleSlashProps) => (
  <IconContainer width="37" height="21" viewBox="0 0 37 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.3335 0.835938H12.3335L2.3335 20.8359H0.333496L10.3335 0.835938Z" fill={color} />
    <path d="M22.3335 0.835938H24.3335L14.3335 20.8359H12.3335L22.3335 0.835938Z" fill={color} />
    <path d="M34.3335 0.835938H36.3335L26.3335 20.8359H24.3335L34.3335 0.835938Z" fill={color} />
  </IconContainer>
);

export default TripleSlashIcon;
